import styled from 'styled-components/macro';
import { Coords } from '../../../../types';

export const Wrapper = styled.div<{
  coords: Coords;
  height: number;
}>`
  z-index: 99999;
  background-color: white;
  position: absolute;
  left: ${(props) => `${props.coords.left}px`};
  top: ${(props) =>
    `${
      props.coords.top +
      5 -
      (props.coords.top + props.height + 5 > window.innerHeight
        ? props.height + 56
        : 0)
    }px`};
  width: ${(props) => `${props.coords.width}px`};
  border-radius: 8px;
  border: 1px solid #ced5de;
  padding: 4px 0;
  box-shadow: 0 2px 4px 0 rgba(15, 23, 40, 0.04),
    0 4px 8px 0 rgba(15, 23, 40, 0.12), 0 0 10px 6px rgba(15, 23, 40, 0.04);
`;

export const OptionsWrapper = styled.div`
  display: flex;
  max-height: 250px;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  font-size: 50px;
  height: 62px;

  & > i {
    color: #d8deeb;
  }
`;
